/**
 * Endpoint used for fetching the tenant config JSON object with the provided `identifier`.
 */
export const tenantConfigUrl = (identifier: string) => `${identifier}.json`;

export const fetchTenantListUrl = () => '/public.json';
